import { render, staticRenderFns } from "./FilterText.vue?vue&type=template&id=3cb513a2&"
import script from "./FilterText.vue?vue&type=script&lang=ts&"
export * from "./FilterText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports